module.exports = __webpack_public_path__ + "img/liverpool.de4eeb24.png";